export class QueryParamHelper {
  static getUrlQueryParamValue(queryParamKey: string): string | null {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get(queryParamKey);
  }

  static getSavedQueryParamValue(queryParamKey: string, sessionStorageKey: string): string | null {
    const queryParamKeyValueString = (sessionStorage.getItem(sessionStorageKey) || '')
      .split('&')
      .find((queryParamKeyValueString) => {
        const [key] = queryParamKeyValueString.split('=');
        return key === queryParamKey;
      });

    const queryParamValue = queryParamKeyValueString?.split('=')?.[1];

    return queryParamValue || null;
  }
}
